module.exports = __webpack_public_path__ + "img/rank2.eb4343c3.png";